import { exportAbility, isReadOnlyUser, userHasClaims } from "../utils/auth";
import { useFeatureFlag } from "./useLaunchDarkly";

export const EXPORT_DISABLED_MESSAGE =
  "Your account doesn't have access to the export feature. Please contact your Customer Success Manager to get this enabled.";

export const READ_ONLY_EXPORT_DISABLED_MESSAGE =
  "Read-only users can't export data.";

export const useExportVisibility = () => {
  // Universe users build Covered Wagon deliveries from the export dialog, so
  // they can open it whatever the tenant's export entitlement — but read-only
  // (RBAC v2) users never export.
  const universeJsonExportEnabled = useFeatureFlag("universeJsonExport", false);
  if (isReadOnlyUser()) return false;
  if (universeJsonExportEnabled) return true;
  return userHasClaims([exportAbility]);
};

// Universe users may export the whole universe, so the Companies export dialog
// doesn't wait for filters for them.
export const useExportRequiresFilters = () =>
  !useFeatureFlag("universeJsonExport", false);

// Tooltip shown on a disabled export control. Read-only users get a
// role-specific message; everyone else keeps the generic "no export access" one.
export const useExportDisabledMessage = (): string =>
  isReadOnlyUser()
    ? READ_ONLY_EXPORT_DISABLED_MESSAGE
    : EXPORT_DISABLED_MESSAGE;
